import { render, staticRenderFns } from "./CustomFieldEdit.vue?vue&type=template&id=1a815842&"
import script from "./CustomFieldEdit.vue?vue&type=script&lang=js&"
export * from "./CustomFieldEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports